import styled from 'styled-components';
import Button from './Button';
import { H1 } from './Heading';
import { ContentStatus } from './StatusLabel';

/**
 * the Page component; should contain a PageHead and PageBody
 */
export default styled.div`
  flex: 1;
  width: 100%;
  padding: 0 0 100px 0;
`;

/**
 * @component PageHead
 *
 * wraps the entire page head, contains title, actions, return link, and any subheads
 * H1 wrapped within this component will look like H2
 * while keeping its semantic meaning to a heading level 1
 * Note: Padding has increased from 24px 60px 16px for consistency
 * with old pages
 */
export const PageHead = styled.div.attrs(() => ({
  'data-no-print': true,
}))`
  background-color: var(--white);
  border-bottom: 1px solid var(--ui-horizontal-separator);
  padding: 40px 60px 25px;
  display: flex;
  flex-flow: row wrap;
  width: 100%;

  > ${H1} {
    width: 50%;
  }

  ${H1} {
    font-weight: var(--normal);
    font-size: var(--x-large);
    line-height: 1.5em;
    letter-spacing: 0;
  }
`;

/**
 * @component PageTitle
 *
 * wraps the title / labels in the header
 */
export const PageTitle = styled.div`
  align-items: center;
  display: flex;
  width: 50%;

  > ${ContentStatus} {
    margin-left: 16px;
  }
`;

/**
 * @component PageActions
 *
 * wraps the buttons/links in the header
 */
export const PageActions = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  width: 50%;
  > ${Button} {
    margin-left: 8px;
  }
`;

/**
 * @component PageReturn
 *
 * container for the return link/breadcrumbs
 */
export const PageReturn = styled.div`
  width: 100%;
`;

/**
 * @component PageSubhead
 *
 * wraps content items beneath the title and actions
 */
export const PageSubhead = styled.div`
  padding-top: 16px;
  width: 100%;
`;

/**
 * @component PageBody
 *
 * wraps all the content below the head, providing the gutters
 */
export const PageBody = styled.section`
  margin: 0 auto;
  max-width: 1240px;
  padding: 16px 60px 0;
  width: 100%;

  @media print {
    padding: 5px;
  }
`;
